module.exports = __webpack_public_path__ + "static/media/car4.7b0694ab.jpg";